import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { hasWorkerApi } from '@/lib/hasWorkerApi';
import { placesWithDistance } from '@shared/places';
import type { PlaceWithDistance } from '@shared/types';

function seedPlaces(): PlaceWithDistance[] {
  return placesWithDistance();
}

export function usePlaces() {
  const [places, setPlaces] = useState<PlaceWithDistance[]>(seedPlaces);
  const [loading, setLoading] = useState(() => hasWorkerApi());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!hasWorkerApi()) {
      setPlaces(seedPlaces());
      setLoading(false);
      return;
    }
    let cancelled = false;
    api
      .get<{ places: PlaceWithDistance[] }>('/places')
      .then((res) => {
        if (cancelled) return;
        if (res.places?.length) setPlaces(res.places);
        else setPlaces(seedPlaces());
      })
      .catch(() => {
        if (cancelled) return;
        setPlaces(seedPlaces());
        setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { places, loading, error };
}
